import { render, staticRenderFns } from "./SidebarToday.vue?vue&type=template&id=33d9cdf9&"
import script from "./SidebarToday.vue?vue&type=script&lang=js&"
export * from "./SidebarToday.vue?vue&type=script&lang=js&"
import style0 from "./SidebarToday.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports